import { Component, Prop, Vue } from 'vue-property-decorator';
import { CHARACTERISTICS } from '@/constants';
import EmojiCharacteristicBar from '@/components/pages/project-evaluation/project-peer-evaluation/pop-up-peer-rating/emoji-rating/emoji-characteristic-bar/EmojiCharacteristicBar.vue';
import EmotionIcon from '@/components/common/emotion-icon/EmotionIcon.vue';
import { MemberPeerEvaluationDTO, EmojiRate } from '@/models';

interface EmojiRatedByCharacter {
  emojiRated: EmojiRate;
  character: string;
}

@Component({
  components: {
    EmojiCharacteristicBar,
    EmotionIcon
  }
})
export default class EmojiRating extends Vue {
  @Prop({ default: false }) isEditing: boolean;
  @Prop({}) userPeerEvaluation: MemberPeerEvaluationDTO;

  private characteristics = CHARACTERISTICS;
  private userRatingPoint = {} as MemberPeerEvaluationDTO;
  private placeholder = `Please put your comment here`;

  onUpdateComment(): void {
    this.$emit('onUpdateRating', this.userRatingPoint);
  }

  onUpdateEmojiRate({ ...emojiRatedByCharacter }: EmojiRatedByCharacter): void {
    if (emojiRatedByCharacter.character === this.characteristics.ACCOUNTABILITY.name) {
      this.userRatingPoint.accountabilityPoint = emojiRatedByCharacter.emojiRated.point;
    } else if (emojiRatedByCharacter.character === this.characteristics.COMMUNICATION.name) {
      this.userRatingPoint.communicationPoint = emojiRatedByCharacter.emojiRated.point;
    } else if (emojiRatedByCharacter.character === this.characteristics.PERSONAL_ATTRIBUTES.name) {
      this.userRatingPoint.personalAttributesPoint = emojiRatedByCharacter.emojiRated.point;
    } else if (emojiRatedByCharacter.character === this.characteristics.PROFESSIONAL_CONDUCT.name) {
      this.userRatingPoint.professionalConductPoint = emojiRatedByCharacter.emojiRated.point;
    } else {
      this.userRatingPoint.supportivenessPoint = emojiRatedByCharacter.emojiRated.point;
    }
    this.$emit('onUpdateRating', this.userRatingPoint);
  }
}
